import React from 'react';

import { reverse } from 'named-urls';
import { Link } from 'react-router-dom';

import DueDate from 'components/DueDate';
import { DetailsRowContainer } from 'components/Entities/AddEntityModal/styles';
import UserRow from 'components/UserRow';

import { InputHeader } from 'containers/Audits/components/StartAuditModal/styles';
import ControlStatusChip from 'containers/Controls/components/ControlStatusChip';
import { ControlStatus } from 'containers/Controls/constants';

import { EntityModules } from 'core/constants';
import routes from 'core/routes';

import { RiskControlOption } from 'utils/api/modules/entities/entities.types';
import { formatLibraryId } from 'utils/formatters/libraryId';

import { OriginCaption, ReadOnlyValue, SectionHeading } from './styles';

const ControlSummary: React.FunctionComponent<{ control: RiskControlOption }> = ({ control }) => {
  const rows: [string, React.ReactNode][] = [
    ['Status', <ControlStatusChip key="status" status={control.status} />],
    ['Owner', <UserRow key="owner" user={control.owner} />],
    ...(control.status === ControlStatus.Proposed
      ? ([['Due date', control.dueDate ? <DueDate key="due" date={control.dueDate} showTime /> : '-']] as [
          string,
          React.ReactNode,
        ][])
      : []),
    ['ID', formatLibraryId(EntityModules.Controls, control.id) || '-'],
    ['Description', control.description || '-'],
    ['Category', control.category?.name ?? '-'],
  ];

  return (
    <div data-testid="add-risk-control-summary">
      <SectionHeading>Control details</SectionHeading>
      <OriginCaption>
        The same on every risk this control is on. To change them,{' '}
        <Link to={reverse(routes.dashboard.risks.controlDetails, { entityId: control.uuid })}>open the control</Link>.
      </OriginCaption>
      {rows.map(([label, value]) => (
        <DetailsRowContainer key={label}>
          <InputHeader>{label}</InputHeader>
          <ReadOnlyValue>{value}</ReadOnlyValue>
        </DetailsRowContainer>
      ))}
    </div>
  );
};

export default ControlSummary;
